// ── shared lead-hold rules: keep identical with both Edge Functions ─────────

export type LeadHold = {
  email_hold_until: string | null;
  email_hold_note: string;
};

export function isLeadHeld(lead: LeadHold, today: string): boolean {
  return (
    (lead.email_hold_until === null && lead.email_hold_note.trim() !== '') ||
    (lead.email_hold_until !== null && today < lead.email_hold_until)
  );
}

export function holdLabel(lead: LeadHold): string {
  if (lead.email_hold_until === null) return 'On hold';
  const date = new Date(`${lead.email_hold_until}T00:00:00Z`);
  return `Hold until ${date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  })}`;
}

// ── end shared lead-hold rules ─────────────────────────────────────────────
